export const FILE_LIST_COLUMNS = [
  ["uploaded_at", "업로드 일시", 160], ["file_name", "파일명", 240],
  ["is_corrupted", "파일 상태", 100], ["file_type", "파일 유형", 100],
  ["building_name", "건물명", 160], ["floor", "층", 100], ["location", "위치", 160],
  ["facility_type", "설비 구분", 130], ["facility_name", "설비명", 140],
  ["part_name", "부품명", 160], ["preview", "미리보기 및 수정", 130],
];
export const MIN_FILE_LIST_COLUMNS = 5;

export function readFileListColumns(userId) {
  try {
    const value = JSON.parse(localStorage.getItem(`file_list_columns_v1:${userId}`));
    if (Array.isArray(value)) {
      const valid = FILE_LIST_COLUMNS.map(([key]) => key).filter(key => value.includes(key));
      if (valid.length) {
        const missing = FILE_LIST_COLUMNS.map(([key]) => key).filter(key => !valid.includes(key));
        return [...valid, ...missing].slice(0, Math.max(MIN_FILE_LIST_COLUMNS, valid.length));
      }
    }
  } catch { /* Storage is optional. */ }
  return FILE_LIST_COLUMNS.map(([key]) => key);
}
